import React from 'react';
import { ActionButton } from '@components/Table/table.utils';
import { Edit } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { Box, useTheme } from '@mui/material';
import { iconSize } from '@fabric-ui/utils';
import { useAvContext } from '../../context/AvContextProvider';
import { PermissionEntitiesNames } from '../../types';
import RulesList, { itemStyle, rulesListItemStyle } from '../Settings/GroupingRules/RulesList';
import { SourcePriorityRule, SourcePriorityRuleConfig } from './types';

interface SourcePriorityRuleConfigProps {
  ruleConfig: SourcePriorityRuleConfig;
  ruleId: string;
  onChangeSources: (updatedSources: any) => void;
  onActive: (ruleId: string) => void;
  headCellsForSources: any;
  isLoading: boolean;
  urlId?: string;
  fieldName?: string;
}
const SourcePriorityRuleConfigComponent: React.FC<SourcePriorityRuleConfigProps> = ({
  ruleConfig,
  ruleId,
  onChangeSources,
  onActive,
  headCellsForSources,
  isLoading,
  urlId,
  fieldName,
}) => {
  const { palette } = useTheme();
  const {
    accountEntities: { fieldMap },
  } = useAvContext();
  return (
    <Box sx={{ ...flex.col, gap: 2, '> div:first-of-type': { maxWidth: 600 } }}>
      {ruleConfig.sourcePriority?.length > 0 && (
        <RulesList<SourcePriorityRule>
          rules={ruleConfig.sourcePriority}
          onChange={onChangeSources}
          onEdit={() => onActive(ruleId)}
          findDefaultFallbackRule={() => false}
          headCells={headCellsForSources}
          isLoading={isLoading}
          active={urlId}
          projectionName={fieldMap[fieldName as string].mainProjId.name}
          permissionConfiguration={{ resource: PermissionEntitiesNames.MODEL }}
          buttonProps={{ clone: { isHidden: true } }}
          variant="compact"
        />
      )}
      {ruleConfig.expression && (
        <Box sx={{ ...flex.col, gap: 1, ml: 5.5 }}>
          <Box sx={{ ...flex.itemsCenter, gap: 1, color: palette.colors.neutrals[700], fontWeight: 600, ml: 5 }}>Result Expression</Box>
          <Box
            sx={[
              {
                ...flex.justifyBetweenCenter,
                pl: 4.5,
                pr: 3,
              },
              rulesListItemStyle({ hasEdit: true, variant: 'compact' }),
            ]}
            onClick={() => onActive(ruleId)}>
            <Box sx={itemStyle('compact')}>{ruleConfig.expression}</Box>
            <Box sx={flex.row}>{ActionButton('Edit', () => onActive(ruleId), <Edit style={iconSize(18)} />)}</Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SourcePriorityRuleConfigComponent;
